
import { useState } from "react";
import { websites } from "webModule/websites";
import { Topic } from "shared/components/topic.component";
import "./topic.style.css";
import { HorizontalSelector } from "./horizontal.selector.component";

export function WebsiteTopic() {
    const [actualWebsite, setActualWebsite] = useState(0);
    return (
        <Topic title="Websites" titleLink="/web">
            <div className="flexVertical height100pr flexJustifySpaceBetween topicContentContainer">
                <div>
                    <div className="flexHorizontal flexJustifyCenter mb10px">
                        <img
                            className="thumbnail"
                            src={websites[actualWebsite].thumbnail}
                            alt={websites[actualWebsite].title + "'s thumbnail"}
                        />
                    </div>
                    <div className="topicContent">
                        <h1 className="textAllignCenter">{websites[actualWebsite].title}</h1>
                    </div>
                </div>
            </div>
            <HorizontalSelector objects={websites} setActualObject={setActualWebsite} />
        </Topic>
    );
}
